// extracted by mini-css-extract-plugin
export var userItem = "UserItem_userItem__ep7xH";
export var imgWrapper = "UserItem_imgWrapper__yZ2Ii";
export var img = "UserItem_img__gd81c";
export var textRole = "UserItem_textRole__mrxhR";
export var textName = "UserItem_textName__Hldrt";
export var rotate = "UserItem_rotate__FhRRG";
export var dotty = "UserItem_dotty__06ruG";